import { Injectable } from '@angular/core';
import { IMachineStatus } from 'src/app/modules/widget/interfaces/machine-status';
import { StatusService } from 'src/app/modules/core/services/parameter';
import { IStatus, IShift } from 'src/app/modules/core/interfaces';
import { ParameterHandlerService } from 'projects/common/src/app/services';
import { IMachineContext } from 'projects/common/src/app/interfaces/machine-context';
import { IMachineStatusParams } from 'src/app/modules/widget/interfaces/machine-status-params';
import { IUser } from 'projects/common/src/app/interfaces';
import { IMachineType } from 'projects/common/src/app/interfaces/machine-type';
import { CacheService } from '../../../../../../projects/common/src/app/services/cache.service';

@Injectable({
  providedIn: 'root',
})
export class MachineStatusService {
  private machineCollection: IMachineStatus[];

  constructor(
    private statusService: StatusService,
    private parameterHandlerService: ParameterHandlerService,
    private cacheService: CacheService,
  ) {
    this.machineCollection = [];
  }

  /**
   * Function to complete the machine status data (related to status)
   */
  public async completeMachineStatus(machineCollection: IMachineStatus[]): Promise<IMachineStatus[]> {
    try {
      const machinePromises = machineCollection.map(async (machine) => {
        const status: IStatus[] = await this.statusService.getStatusById(machine.statusId).toPromise();
        machine.statusType = status[0] ? status[0].statusFamilyId : 0;
        machine.machineType = (this.parameterHandlerService.parameters.item('machine-context').value as IMachineContext).name;
        machine.statusImage = status[0] ? status[0].statusImage : 'default';
        return machine;
      });

      this.machineCollection = await Promise.all(machinePromises);
      return this.machineCollection;
    } catch (error) {
      throw new Error(`Error completing machine status: ${error.message}`);
    }
  }

  /**
   * Function to change the machine context
   * @param machineCollection: Machine collection
   */
  public setNewMachineContext(machineCollection: IMachineStatus[], context: number): Promise<IMachineStatus[]> {
    return new Promise((resolve, reject) => {
      this.machineCollection = [];
      for (const machine of machineCollection) {
        machine.machineTypeId = context;
        this.machineCollection.push(machine);
      }

      resolve(this.machineCollection);
    });
  }

  /**
   * Function to get status in machine
   */
  public async getStatusInMachine(): Promise<any> {
    const machineCollection = this.parameterHandlerService.parameters.item('machine-collection').value as IMachineType[];
    const currentMachine = this.parameterHandlerService.parameters.item('machine-context').value.name as string;

    const { machineTypeId } = machineCollection.find((value) => String(value.name).toLowerCase() === String(currentMachine).toLowerCase());

    const params: IMachineStatusParams = {
      inputDate: this.parameterHandlerService.parameters.item('date').value,
      machineTypeId,
      shiftId: String((this.parameterHandlerService.parameters.item('shift').value as IShift).shiftId),
      companyId: String((this.parameterHandlerService.parameters.item('user-data').value as IUser).company.id),
      zoneId: this.cacheService.session('selectedZone').zoneId,
    };

    return this.statusService.getAllMachineStatus(params).toPromise();
  }

  /**
   * Function to get machines by status
   */
  public getStatusByMachine(): Promise<any> {
    const machineCollection = this.parameterHandlerService.parameters.item('machine-collection').value as IMachineType[];
    const currentMachine = this.parameterHandlerService.parameters.item('machine-context').value.name as string;

    const { machineTypeId } = machineCollection.find((value) => String(value.name).toLowerCase() === String(currentMachine).toLowerCase());

    const params = {
      inputDate: this.parameterHandlerService.parameters.item('date').value,
      machineTypeId,
      shiftId: String((this.parameterHandlerService.parameters.item('shift').value as IShift).shiftId),
      companyId: String((this.parameterHandlerService.parameters.item('user-data').value as IUser).company.id),
      zoneId: this.cacheService.session('selectedZone').zoneId,
    };

    return this.statusService.getAllMachineStatus(params).toPromise();
  }
}
